/* The offline india-pincode-search DB is ~3.2MB. Loading it statically bakes
   it into the main bundle every visitor downloads; this loader code-splits it
   into its own chunk, fetched once on first use (pages prefetch it on mount).
   If the chunk ever fails to load, callers fall back to the India Post API. */
let pincodeDbPromise = null;

export const loadPincodeDb = () => {
  if (!pincodeDbPromise) {
    pincodeDbPromise = import("india-pincode-search").then((m) => m.default).catch(() => null);
  }
  return pincodeDbPromise;
};
